import { Injectable } from '@angular/core';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DailySalesService {

  


  constructor(private http: HttpClient) { }

  getShopList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/common/shop/get', requestData);

  }
    exportDailySales(data:any): Observable<any> {
      return this.http.post(
        environment.baseUrl+'/hq/daily-sales/get', 
        data, 
        { responseType: 'blob' }
  );
    }
}
